// import { Curve } from '../core/Curve.js';
// import { CatmullRom } from '../core/Interpolations.js';
// import { Vector2 } from '../../math/Vector2.js';
import * as THREE from 'three';

 export function ClosedSplineCurve(points = []) {
    THREE.Curve.call(this);
    this.type = 'ClosedSplineCurve';
    this.points = points;
}

function indexRound(i, len) {
    if (i < 0) return i + len;
    if (i >= len) return i - len;
    return i;
}

function CatmullRom( t, p0, p1, p2, p3 ) {
	const v0 = ( p2 - p0 ) * 0.5;
	const v1 = ( p3 - p1 ) * 0.5;
	const t2 = t * t;
	const t3 = t * t2;
	return ( 2 * p1 - 2 * p2 + v0 + v1 ) * t3 + ( - 3 * p1 + 3 * p2 - 2 * v0 - v1 ) * t2 + v0 * t + p1;
}

ClosedSplineCurve.prototype = Object.create(THREE.Curve.prototype);
ClosedSplineCurve.prototype.constructor = ClosedSplineCurve;

ClosedSplineCurve.prototype.isClosedSplineCurve = true;

ClosedSplineCurve.prototype.getPoint = function (t, optionalTarget = new THREE.Vector2()) {
    const point = optionalTarget;
    const points = this.points;
    const p = points.length * t;
    const intPoint = Math.floor(p);
    const weight = p - intPoint;
    const p0 = points[indexRound(intPoint - 1, points.length)];
    const p1 = points[indexRound(intPoint, points.length)];
    const p2 = points[indexRound(intPoint + 1, points.length)];
    const p3 = points[indexRound(intPoint + 2, points.length)];
    // console.log(intPoint, points, p0, p1, p2, p3);

    point.set(
        CatmullRom(weight, p0.x, p1.x, p2.x, p3.x),
        CatmullRom(weight, p0.y, p1.y, p2.y, p3.y)
    );

    return point;
};

ClosedSplineCurve.prototype.getPoints = function (divisions = 5) {
    const points = [];
    for (let d = 0; d < divisions; d++) {
        points.push(this.getPoint(d / divisions));
    }
    return points;
},

ClosedSplineCurve.prototype.copy = function (source) {
    THREE.Curve.prototype.copy.call(this, source);
    this.points = [];
    for (let i = 0, l = source.points.length; i < l; i++) {
        const point = source.points[i];
        this.points.push(point.clone());
    }
    return this;
};

ClosedSplineCurve.prototype.toJSON = function () {
    const data = Curve.prototype.toJSON.call(this);
    data.points = [];
    for (let i = 0, l = this.points.length; i < l; i++) {
        const point = this.points[i];
        data.points.push(point.toArray());
    }
    return data;
};

ClosedSplineCurve.prototype.fromJSON = function (json) {
    THREE.Curve.prototype.fromJSON.call(this, json);
    this.points = [];
    for (let i = 0, l = json.points.length; i < l; i++) {
        const point = json.points[i];
        this.points.push(new Vector2().fromArray(point));
    }
    return this;
};




// WEBPACK FOOTER //
// ./src/views/reliefVase/scripts/ClosedSplineCurve.js